var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    !_vm.failed
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("van-loading", { attrs: { size: "50" } })],
          1
        )
      : _c("p", { staticClass: "error-text", attrs: { role: "alert" } }, [
          _vm._v(_vm._s(_vm.errorMessage)),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }